import { Avatar, Button, Container, Heading, HStack, Image, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text, useDisclosure, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { RiDeleteBin7Fill } from 'react-icons/ri'
import { useSelector } from 'react-redux'
import {Link} from 'react-router-dom'
const ProfilePage = () => {
    const user = {
        name: 'abhi',
        email:'ok@123',
        createdOn:String(new Date()),
        role:'adminl',
        subscription:{
            status:'active'
        },
        playlist:[
            {
                course: 'sadsad',poster:'https://upload.wikimedia.org/wikipedia/en/c/cb/Monkey_D_Luffy.png'
            }
        ]
    }
    // const [user,setUser] = useState("");

    const {user2} = useSelector(state=>state.user);
    console.log(user2);
    const {name,email,createdOn,role,subscription} = user;
    const removeFromPlaylistHandler=id=>{
        console.log(id)
    }
    // const {isOpen,onClose,onOpen} = useDisclosure();
    // const changeImgSubmitHandler = (e,img)=>{
    //     e.preventDefault();
    // }
  return (
    <Container minH={'95vh'} maxW='container.lg' py='8'>
        <Heading children='Profile' m='8' textTransform={'uppercase'} />
        <Stack justifyContent={'flex-start'} direction={['column','row']} alignItems={'center'} spacing={['8','16']}>
            {/* <VStack>
                <Avatar boxSize={'48'} />
                <Button onClick={onOpen} colorScheme={'pink'} variant='outline'>
                    Change Avatar
                </Button>
            </VStack> */}
            <VStack spacing={'4'} alignItems={['center','flex-start']}>
                <HStack>
                    <Text children="Name" fontWeight={'bold'}/>
                    <Text children={`${name}`} />
                </HStack>
                <HStack>
                    <Text children="EMail" fontWeight={'bold'}/>
                    <Text children={`${email}`} />
                </HStack>
                <HStack>
                    <Text children="Created on" fontWeight={'bold'}/>
                    <Text children={`${createdOn.split('T')[0]}`} />
                </HStack>
                {role && role!=='admin' && (
                <HStack>
                    <Text children='Subscription' fontWeight={'bold'}/>
                    {subscription &&  subscription.status==='active' ? (
                        <Button colorScheme={'pink'} variant='ghost'>Cancel Subscription</Button>
                    ):(
                        <Link to="/subscribe">
                            <Button colorScheme={'pink'}>
                                Subscribe
                            </Button>
                        </Link>
                    )}
                    </HStack>
                    )
                }
                <Stack direction={['column','row']} alignItems={'center'}>
                    <Link to="/updateprofile">
                        <Button>Update Profile</Button> 
                    </Link>
                    <Link to="/changepassword">
                        <Button>Change Password</Button>
                    </Link>
                </Stack>
            </VStack>
        </Stack>
        <Heading children='Playlist' size={'md'} my='8'/>
        {
            user.playlist.length>0 && (
                <Stack direction={['column','row']} alignItems={'center'} flexWrap='wrap' p='4'>
                    {
                        user.playlist.map((element,index)=>(
                            <VStack w='48' m='2' key={element.course}>
                                <Image boxSize={'full'} objectFit='contain' src={element.poster}/>
                                <HStack>
                                    <Link to={`/course/${element.course}`}>
                                        <Button variant={'outline'} colorScheme='pink'>
                                            Learn Now
                                        </Button>
                                    </Link>
                                    <Button onClick={()=>removeFromPlaylistHandler(element.course)}>
                                        <RiDeleteBin7Fill/>
                                    </Button>
                                </HStack>
                            </VStack>
                        ))
                    }
                </Stack>
            )
        }
        {/* <ChangeAvatarBox changeImgSubmitHandler={changeImgSubmitHandler} isOpen={isOpen} onClose={onClose}/> */}
    </Container>
  )
}

export default ProfilePage;

function ChangeAvatarBox({isOpen,onClose,changeImgSubmitHandler}){

    const [img,setImg]=useState();
    const [imgPrev,setImgPrev]=useState();

    const changeImage=(e)=>{
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onloadend=()=>{
            setImgPrev(reader.result);
            setImg(file);
        }
    }
    const closeHandler = ()=>{
        onClose();
        setImg('');
        setImgPrev('');
    }
    return(
        <Modal isOpen={isOpen} onClose={closeHandler}>
            <ModalOverlay backdropFilter={'blur(10px'}/>
            <ModalContent>
                <ModalHeader>
                    Change Avatar
                </ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Container>
                        <form onSubmit={(e)=>changeImgSubmitHandler(e,img)}>
                            <VStack spacing={'8'}>
                                {
                                    imgPrev && <Avatar src={imgPrev} boxSize={'48'} />
                                }
                                {/* <Avatar src={imgPrev} boxSize={'48'}/> */}
                                <Input type={'file'} css={{
                                    "&::file-selector-button":{
                                    cursor:"pointer",marginLeft:"-5%",
                                    width:"110%",
                                    border:"none",
                                    height:"100%",
                                    color:'#ECC94B',
                                    backgroundColor:'white'
                                    }
                                }}
                                onChange={changeImage}
                                />
                                <Button w='full' colorScheme={'pink'} type='submit'>Change the Avatar</Button>
                            </VStack>
                        </form>
                    </Container>
                </ModalBody>
                <ModalFooter>
                    <Button mr='3' onClick={closeHandler}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}